import React from "react";
import "./banner.css";
import useBannerData from "./useBannerData";

export default function BannerPreview({ widgetInformation }) {
  const { bannerData, loading, reloadImage } = useBannerData(
    widgetInformation,
  );
  return (
    <div
      className={`banner-container show-frame`}
      role="banner"
    >
      <div className="image-container">
        {loading || !bannerData?.imageURL ? (
          <span className="overflow-ellipsis">Banner</span>
        ) : (
          <img
            src={`${bannerData?.imageURL}`}
            alt="img"
            onError={reloadImage}
          />
        )}
      </div>
    </div>
  );
}
